<template>
  <div @click="tablesToExcel()">
    <slot></slot>
  </div>
</template>

<script>
  import {getTimeDiff, updateTimeByUtc} from 'common/js/util'
  export default {
    data () {
      return {
        firstData: [],
        secondData: [],
        firstHead: [],
        secondHead: []
      }
    },
    props: {
      rID: {
        default: ''
      },
      firstTh: {
        type: Object,
        default: () => {}
      },
      secondTh: {
        type: Object,
        default: () => {}
      },
      sheetName:{
        type: Array,
        default: () => []
      },
      downloadName: {
        default: 'download'
      },
      ajaxUrl: {
        default: false
      },
      dataTh: {
        default: false
      },
      ajaxGetKey: {
        default: false
      },
      ajaxPar: {
        default: {}
      },
      ajaxType: {
        default: "get"
      }
    },
    methods: {
        tablesToExcel() {
            let curArea = JSON.parse(sessionStorage.getItem('currentArea'))
            let id = this.rID ? " " + this.rID : ''
            let name = this.downloadName ? " " + this.downloadName : ''
            let wbname = curArea.value + ' ' + name + id
            let ajaxPar = this.ajaxType === "post" ? this.ajaxPar : {params: this.ajaxPar}
            this.$http[this.ajaxType](this.ajaxUrl, ajaxPar).then((res) => {
              let getVal = (obj, arr) => {
                  if (arr.length > 1) {
                    return getVal(obj[arr[0]], arr.slice(1))
                  } else {
                    return obj[arr[0]]
                  }
              }
              let getTableHeadAndBody = (head, bodyData, langObj) => {
                let tmpObj
                // ���dataThΪtrue,��ȡ�÷����ļ��ı���ͷ������������ͷ
                if(this.dataTh) {
                  tmpObj = langObj.th
                }else {
                  tmpObj = bodyData[0] ? bodyData[0] : langObj.th
                }
                let thKeys = Object.keys(tmpObj)
                for(let item of thKeys){
                  head.push({ key:item, name:langObj.th[item] })
                }
                let tmpArr = Object.keys(langObj).filter(v => v != 'th')
                bodyData.forEach((val,index) => {
                  for(let key of tmpArr){
                    let tmpObj = langObj[key]
                    val[key] = (val[key] || val[key] == 0) ? tmpObj['changeTime'] ? updateTimeByUtc(getTimeDiff(), val[key]) : tmpObj[val[key]] : ''
                  }
                });
              }
              let data = getVal(res, this.ajaxGetKey)
              this.firstData = data[0]
              this.secondData = data[1]
              this.firstHead = []
              this.secondHead = []
              getTableHeadAndBody(this.firstHead,this.firstData,this.firstTh)
              getTableHeadAndBody(this.secondHead,this.secondData,this.secondTh)
              this.export2Excel(wbname)
            })   
        },
        export2Excel(excelName) {
          require.ensure([], () => {
            const { export_json_to_multi_excel } = require('@/vendor/Export2Excel')
            const firstHeader = this.getHeadKeyOrName(this.firstHead, 'name')
            const firstKey = this.getHeadKeyOrName(this.firstHead, 'key')
            const secondHeader = this.getHeadKeyOrName(this.secondHead, 'name')
            const secondKey = this.getHeadKeyOrName(this.secondHead, 'key')
            const data = [this.formatJson(firstKey, this.firstData),this.formatJson(secondKey, this.secondData)]
            export_json_to_multi_excel([firstHeader, secondHeader], data, this.sheetName, excelName)
          })
        },
        formatJson(filterVal, jsonData) {
          return jsonData.map(v => filterVal.map(j => v[j]))
        },
        getHeadKeyOrName (thArr, type) {
          let arr = []
          thArr.forEach((item) => {
            if((item.flag === undefined || item.flag) && (item.unneed === undefined || item.unneed)){
              arr.push(item[type])
            }  
          })
          return arr
        }
    }
  }
</script>



// WEBPACK FOOTER //
// multiSheetExcel.vue?694addbf